import { render } from "./Actie.vue?vue&type=template&id=13cd6ab7"
import script from "./Actie.vue?vue&type=script&lang=js"
export * from "./Actie.vue?vue&type=script&lang=js"

import "./Actie.vue?vue&type=style&index=0&id=13cd6ab7&lang=css"

import exportComponent from "C:\\Users\\benja\\Desktop\\SKWinkelStarter\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__